// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:53:39

export default {
  "id": "perfect-piano-magic",
  "slug": "perfect-piano-magic",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1de0e17bc5374b849c7ac01581d6189d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1de0e17bc5374b849c7ac01581d6189d/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Perfect Piano Magic",
      "description": "Perfect Piano Magic is a fun casual game. If you are a big fan of Piano Magic games, then this is a game you can't afford to miss! The gameplay of this game is extremely similar to Piano Magic, you need to shoot the blocks with a gun to capture the beat. You have three chances per game, start now and feel the real music when you click the blocks, enjoy the beats, and get ready to experience the delightful music and become a rhythm master!",
      "instructions": "Mouse click or tap to play",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "1player"
      ]
    },
    "zh-CN": {
      "title": "完美钢琴魔法",
      "description": "完美钢琴魔法是一款有趣的休闲游戏。如果你是钢琴魔法游戏的忠实粉丝，那么这款游戏你绝对不能错过！这款游戏的游戏玩法与钢琴魔法极为相似，你需要用枪射击方块来捕捉节奏。每局游戏你有三次机会，现在就开始吧，当你点击方块时感受真正的音乐，享受节奏，准备好体验令人愉悦的音乐，成为节奏大师！",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "1玩家"
      ]
    },
    "zh-TW": {
      "title": "完美鋼琴魔法",
      "description": "完美鋼琴魔術是一款有趣的休闲遊戲。如果你是鋼琴魔術遊戲的狂熱粉絲，這是一款你絕對不能錯過的遊戲！這款遊戲的遊玩方式與鋼琴魔術極為相似，你需要用槍射擊塊來捕捉節奏。每場遊戲你有三次機會，現在就開始吧，當你點擊塊時感受真正的音樂，享受節奏，準備好體驗愉悅的音樂，並成為節奏大師！",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "隨意",
        "射擊"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-HK": {
      "title": "完美鋼琴魔法",
      "description": "完美鋼琴魔術是一款有趣的休闲遊戲。如果你是鋼琴魔術遊戲的大粉絲，那麼這是一款你絕對不能錯過的遊戲！這款遊戲的遊玩方式與鋼琴魔術極為相似，你需要用槍射擊方塊來捕捉節奏。每場遊戲你有三次機會，立即開始體驗當你點擊方塊時的真正音樂，享受節奏，準備好去體驗令人愉悅的音樂，並成為節奏大師！",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "隨意射擊遊戲"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "ja": {
      "title": "完璧ピアノマジック",
      "description": "パーフェクトピアノマジックは楽しいカジュアルゲームです。ピアノマジックゲームの大ファンなら、このゲームは見逃せません！このゲームのプレイはピアノマジックに非常に似ており、ブロックを銃で撃ってビートをキャプチャーする必要があります。ゲームごとに3回のチャンスがあります。今すぐ始め、ブロックをクリックして本物の音楽を感じ、ビートを楽しみ、素晴らしい音楽を体験し、リズムマスターになる準備をしよう！",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "1プレイヤー"
      ]
    },
    "ko": {
      "title": "perfekt piānō majik",
      "description": "_perfect 피아노 마법은 재미있는 캐주얼 게임입니다. 피아노 마법 게임의 큰 팬이신다면, 이 게임을 놓칠 수 없는 게임입니다! 이 게임의 게임 플레이는 피아노 마법과 매우 유사합니다. 블록을 쏜다음 비트를 잡아야 합니다. 게임당 3회의 기회를 가지고, 지금 바로 시작하고 블록을 클릭할 때 진정한 음악을 느껴보세요. 비트를 즐기고, 기쁜 음악을 경험하며 리듬 마스터가 되어보세요!_",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "캐주얼",
        "쏜사격"
      ],
      "tags": [
        "1플레이어"
      ]
    },
    "fr": {
      "title": "Piano Magique Parfait",
      "description": "Perfect Piano Magic est un jeu casual amusant. Si vous êtes un grand fan des jeux Piano Magic, alors c'est un jeu que vous ne pouvez pas vous permettre de manquer ! Le gameplay de ce jeu est extrêmement similaire à celui de Piano Magic, vous devez tirer sur les blocs avec une arme pour capturer le rythme. Vous avez trois chances par partie, commencez maintenant et ressentez la vraie musique lorsque vous cliquez sur les blocs, profitez des beats et préparez-vous à vivre la musique délicieuse et à devenir un maître du rythme !",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Facile",
        "TIR"
      ],
      "tags": [
        "1 joueur"
      ]
    }
  }
};
